import { useTranslation } from 'react-i18next';

import type { ChangelogChangelogReadModel } from '@r/api/generated/client.schemas.ts';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';

import { ChangelogForm } from './changelog-form.tsx';

interface ChangelogDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  changelog?: ChangelogChangelogReadModel | null;
}

/**
 * Modale d'édition d'un changelog (la création se fait sur une page dédiée).
 * En-tête figé, seul le corps du formulaire défile.
 */
export function ChangelogDialog({ isOpen, onOpenChange, changelog }: ChangelogDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[85vh] max-w-2xl flex-col gap-0 overflow-hidden p-0">
        <DialogHeader className="shrink-0 border-b px-8 pb-5 pt-8">
          <DialogTitle className="text-2xl">
            {t('fiddy.admin.changelog.edit.dialog.title')}
          </DialogTitle>
          <DialogDescription>
            {t('fiddy.admin.changelog.edit.dialog.description')}
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto px-8 py-6">
          <ChangelogForm changelog={changelog} onSuccess={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
